import { Component, Input, Output, EventEmitter} from 'ng-metadata/core';

@Component({
    "selector": "prm-print-item",
    templateUrl: 'components/search/actions/printAction/print-item.html'
})


export class PrmPrintItem {
    @Output() closeTabsEvent = new EventEmitter<void>();
    constructor() {
    }

    ngOnInit() {
        this.closeTabsEvent.emit(null);
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/printAction/printItem.directive.ts